module.exports = __webpack_public_path__ + "static-v-shop/1765543399050/img/logo_cabal.f797e5ff.png";